"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountingByIdWithSlotsApiResponseSchema = void 0;
const zod_1 = require("zod");
const agenda_slot_1 = require("../agenda-slots/agenda-slot");
const doctor_attending_1 = require("../doctor-attendings/doctor-attending");
const doctor_substitute_1 = require("../doctor-substitutes/doctor-substitute");
const office_1 = require("../offices/office");
const accouting_1 = require("./accouting");
exports.getAccountingByIdWithSlotsApiResponseSchema = zod_1.z.object({
    data: accouting_1.getAccountingApiEntitySchema,
    included: zod_1.z
        .array(zod_1.z.union([
        office_1.simpleOfficeApiSchema,
        doctor_attending_1.simpleDoctorAttendingApiSchema,
        doctor_substitute_1.simpleDoctorSubtituteApiSchema,
        agenda_slot_1.simpleAgendaSlotApiSchema,
    ]))
        .optional()
        .default([]),
});
